import type { LocationQuery } from 'vue-router'

// "manage GOAT account" link from the store: /?goat_token=…&goat_email=…&goat_app=…
// The router guard takes these params out of the URL (redirect to the same address without them) before the navigation
// completes, so the token never reaches the address bar history, the Referer header or GA (page_view / `dl` of any hit);
// the values wait here until siteUtils.updateMode() logs the user in.
export interface GoatLinkParams {
  token: string
  email: string
  app: string
}

// auth params that must never stay in the URL (the unsubscribe `token` is consumed by its own guard branch first)
export const SENSITIVE_QUERY_KEYS = ['goat_token', 'goat_email', 'goat_app', 'token'] as const

export const pendingGoatLink = ref<GoatLinkParams | null>(null)

// strips every sensitive param that is present (also an incomplete link - e.g. only goat_token - so it never lingers in
// the URL); link only for a complete link (goat_token + goat_email, as before); stripped = false -> nothing to redirect
export function takeGoatLinkParams(query: LocationQuery): { link: GoatLinkParams | null, query: LocationQuery, stripped: boolean } {
  const present = SENSITIVE_QUERY_KEYS.filter(key => key in (query ?? {}))
  if (!present.length) {
    return { link: null, query, stripped: false }
  }
  const link: GoatLinkParams | null = query.goat_token && query.goat_email
    ? {
        token: String(query.goat_token),
        email: String(query.goat_email),
        app: query.goat_app ? String(query.goat_app) : ''
      }
    : null
  const cleanQuery: LocationQuery = { ...query }
  present.forEach(key => delete cleanQuery[key])
  return { link, query: cleanQuery, stripped: true }
}
